import { Box, Typography } from "@mui/material";
import { TextFieldProps } from "@mui/material/TextField/TextField";
import { DatePicker } from "@mui/x-date-pickers";
import React, { FC, memo } from "react";
import { Controller } from "react-hook-form";

import { CalendarIcon } from "../icons";
import { formatDatePickerDate, parseDatePickerDate } from "./utils/utils";

interface IMuiDatePicker {
  name: string;
  label?: string;
  required?: boolean;
  textFieldProps?: Partial<TextFieldProps>;

  [key: string]: any;
}

const styles = {
  formControl: {
    width: "100%",
  },
  wrapper: {
    "& .MuiTypography-root": {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "20px",
      color: "#25282D",
      marginBottom: "4px",
    },
  },
  label: {
    "& span": {
      color: "#FF0000"
    }
  }
};

export const defaultProps: Partial<IMuiDatePicker> = {
  required: false,
  textFieldProps: {}
};

const MuiFormDatePicker: FC<IMuiDatePicker> = memo<IMuiDatePicker>(({
  name,
  label,
  required = defaultProps.required,
  textFieldProps = defaultProps.textFieldProps,
  control,
  error,
  placeholder,
  ...otherProps
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const { onChange, value = null, ...otherFieldProps } = field;

        const onChangeValue = (date: Date | null) => {
          onChange(date ? formatDatePickerDate(date) : date);
        };

        const parsedValue = parseDatePickerDate(value);

        return (
          <Box sx={styles.wrapper}>
            {label && (
              <Typography sx={styles.label}>
                {label}
                {required && <span>*</span>}
              </Typography>
            )}
            <DatePicker
              format="yyyy-MM-dd"
              onChange={onChangeValue}
              value={parsedValue}
              {...otherProps}
              slotProps={{
                textField: {
                  placeholder: placeholder,
                  variant: "outlined",
                  autoComplete: "off",
                  sx: styles.formControl,
                  required,
                  error: Boolean(error),
                  helperText: error?.message,
                  ...otherFieldProps,
                  ...textFieldProps
                }
              }}
              slots={{
                openPickerIcon: CalendarIcon
              }}
            />
          </Box>

        );
      }}
    />
  );
});

// const MuiFormDatePicker = (props: IMuiDatePicker) => {
//   const methods = useFormContext();
//   const error = get(methods.formState.errors, props.name);
//
//   return <MuiDatePickerComponent control={methods.control} error={error} {...props} />;
// };

export default MuiFormDatePicker;
